export default __webpack_public_path__ + "static/media/coming_soon.1a5a474f.png";